import { useMissingData } from "./useMissingData";

export const useMissingFields = (verificationLevel: string) => {
  return useMissingData(verificationLevel)?.requiredFields || [];
};
